import { useLayoutEffect, useRef } from "react";

/**
 * Page-turn direction for the View Transition CSS in styles.css.
 *
 * Set while React commits the new page, i.e. inside the view transition's
 * update callback: after the old page was captured and before the new one is.
 * Deriving it from the actual page change (not from which button was pressed)
 * keeps it right for rapid mixed-direction turns and for browser back/forward,
 * which React Router replays with the same view transition.
 */
export function usePageTurnDirection(page: number) {
	const previous = useRef(page);
	useLayoutEffect(() => {
		if (previous.current === page) return;
		document.documentElement.dataset.turn = page > previous.current ? "next" : "prev";
		previous.current = page;
	}, [page]);
}
